import { HotlistComponent } from "@/features/esoPerson/hotlist/HotlistComponent"

export const HotlistPage = () => {
  return <HotlistComponent />
}
